import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useTracking } from './useTracking';
export function ScrollTracking(props) {
    const rootRef = useRef(null);
    const { emitUserInteractionEvent } = useTracking();
    useEffect(() => {
        const root = rootRef.current;
        if (!root) {
            return;
        }
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                emitUserInteractionEvent({
                    event_action: 'in_view',
                    interaction_name: 'component_scrolled_into_view',
                    option_selected: 'div',
                    custom_tracking_fields: {
                        section_name: props.sectionName,
                    },
                });
            }
        });
        observer.observe(root);
        return () => observer.unobserve(root);
    }, [emitUserInteractionEvent, props.sectionName]);
    return _jsx("div", Object.assign({ ref: rootRef }, { children: props.children }));
}
//# sourceMappingURL=ScrollTracking.js.map